import View from './view.js';
import icons from 'url:../../img/icons.svg';
import previewView from './previewView.js';

// ///////////////////////////////////////
class resultsView extends View {
  _parentElement = document.querySelector('.results');
  _errMessage = 'No recipe found for your query! Please try again;)';
  _successMessage = '';

  _generateMarkup() {
    // console.log(this._data);
    return this._data.map(result => previewView.render(result, false)).join('');
  }
}

export default new resultsView();
